(function ClientDuplicateEmail($, Adzuki)
{
	"use strict";

	var dupeEmail = {};

	dupeEmail.confirm = function confirm(response, form_name) {
		var $jForm;

		if (response.data.response_code === "duplicate_email") {

			Adzuki.CustomConfirm({
				body   : response.data.message,
				confirm: function yes() {
					$jForm = $('form[name="' + form_name + '"]');

					// uncheck any opt-in checkboxes that appear after the email address. Now we are going to be saving the email address
					// as an alternate email address, so opt in would not be relevant
					$.each(response.data.fields, function __uncheck() {
						var $email_input = $('#' + this.attributes.id),
						    $opt_ins     = $email_input.closest('.new-client-fields').find(".opt-in");

						$opt_ins.prop('checked', false);
						$opt_ins.attr('disabled', true);

					});

					// set hidden input indicating that the user wants to ignore the dupe email, so we do not throw a confirm again
					$jForm.find('.dupe_emails_proceed').val(1);
					$jForm.submit();
				}
			});
		}
	};

	Adzuki.Erez.ClientDuplicateEmail = dupeEmail;

}(jQuery, window.Adzuki || {}));
